import multipleFieldWidget from "./multipleFieldWidget.js";

/**
 * Form field widget for a multiple checkbox list.
 */
function multipleCheckboxListFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = multipleFieldWidget(spec, my);
	const itemLabel = my.itemLabel || my.deserialize;

	my.itemDisabled = spec.itemDisabled || (() => false);
	my.itemDisabledLabel = spec.itemDisabledLabel || (() => "");

	my.renderFieldOn = function (html) {
		html.div().render((html) => {
			my.items.forEach((item) => {
				html.div(
					{ klass: "checkbox form-control" },
					html.label().render((html) => {
						const checkbox = html.input({ type: "checkbox" });

						if (my.itemDisabled(item)) {
							checkbox.attr({ disabled: "disabled" });
						}
						if (my.isSelected(item)) {
							checkbox.attr({ checked: "checked" });
						}

						checkbox.change(() => {
							onChange(checkbox, item);
						});

						if (my.itemDisabled(item)) {
							html.span(
								{ klass: "disabled-label" },
								my.itemDisabledLabel(item),
							);
						} else {
							html.render(itemLabel(item));
						}
					}),
				);
			});
		});
	};

	my.selectAllItems = function () {
		that.setValue(my.items.filter((item) => !my.itemDisabled(item)));
	};

	function onChange(checkbox, item) {
		if (checkbox.asJQuery().is(":checked")) {
			my.selectItem(item);
		} else {
			my.unselectItem(item);
		}
	}

	return that;
}

export default multipleCheckboxListFieldWidget;
